import React from "react";

import FIlterSelect from "../filter-select";
import Input from "../input";
import { I_Customer } from "../../pages/customers/types";
import { formatDate } from "../../utilz/function";
import { I_Requisition } from "../../pages/requisition/types";
import { I_Supplier } from "../../pages/suppliers/types";

interface OrderDetailsProps {
  control: any;
  errors: any;
  supply?: I_Supplier | null;
}

const SupplierInformation: React.FC<OrderDetailsProps> = ({ supply }) => {
  return (
    <div className="flex flex-col gap-5">
      <div className="items-center gap-4">
       
        <Input
          name="email"
          value={supply?.email || ""}
          className="w-full"
          label="Supplier Email"
        />

        <Input
          name="name"
          value={supply?.contactPerson || ""}
          className="w-full"
          label="Supplier Contact Person"
        />

        <Input
          name="number"
          value={supply?.phone || ""}
          className="w-full"
          label="Supplier Contact Number"
        />

        <div className="mt-3">
          <label className="block text-sm font-medium text-gray-700 ">
            Expected Date of Delivery
          </label>
          <input
            // value={}
            className="w-full border mt-2 rounded-full h-[48px] px-3 border-[#9D9898]"
            type="date"
          />
        </div>
      </div>
    
    </div>
  );
};

export default SupplierInformation;
